import styled from '@emotion/styled';

export const WriteButton = styled.button`
  display:flex;
  gap:8px;
  padding: 7px 12px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 16px */
  letter-spacing: 1px;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
  transition: all 0.2s ease-in-out;
  &:hover {
    // background is primary color but with 0.25 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '40'};
  }
`;
